/* eslint-disable no-unused-vars */
import Headroom from '../vendor/headroom';

let headroom = {};

( function($) {

    headroom.init = function() {
        let msg = document.getElementById( 'js-main-nav-msg' );
        let nav = document.getElementById( 'js-nav-menu' );
        let body = document.getElementsByTagName('body')[0];

        if( msg && nav ) {
            let headroom = new Headroom(nav, {
                offset: msg.offsetHeight,
                classes: {
                    notTop: 'is-fixed-top',
                },
                onTop : function() {
                    msg.classList.remove( 'd-none' );
                    body.classList.remove( 'has-fineprint-hidden' );
                },
                onNotTop : function() {
                    msg.classList.add( 'd-none' );
                    body.classList.add( 'has-fineprint-hidden' );
                },
            } );

            headroom.init();
        }
    };

    headroom.init();

})(jQuery);

window.headroom = headroom;



// WEBPACK FOOTER //
// ./scripts/components/headroom.js